import { NgModule } from '@angular/core';
import { ShapeGridBackgroundComponent } from './shape-grid-background.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        ShapeGridBackgroundComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        ShapeGridBackgroundComponent
    ]
})
export class NcShapeGridBackgroundModule { }